import React, { useState, useEffect } from "react";

function SearchInput({ placeholder, data, onSearchResults,className }) {
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState(data || []);

  useEffect(() => {
    // Filter the data whenever the query or data changes
    if (searchQuery.length >= 3) {
      const results = data.filter((item) =>
        item.title.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setFilteredData(results);
      onSearchResults(results); // Notify parent about filtered results
    } else {
      setFilteredData(data); // Reset to full list if query is too short
      onSearchResults(data); // Notify parent with the full list
    }
  }, [searchQuery, data, onSearchResults]);

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  return (
    <div className={`mb-4 min-w-[750px] ${className}`}>
      <input
        type="text"
        placeholder={placeholder || "Search..."}
        className="w-full p-2 border rounded"
        value={searchQuery}
        onChange={handleSearchChange}
      />
    </div>
  );
}

export default SearchInput;
